export function setWithExpiry(key: string, value: any[] | string) {
  //const now = new Date();

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: new Date().setHours(0, 0, 0, 0),
  };
  const encodedValue = btoa(JSON.stringify(item));
  localStorage.setItem(key, encodedValue);
  // localStorage.setItem(key, JSON.stringify(item));
}

export function getWithExpiry(key: string) {
  const itemStr = localStorage.getItem(key);

  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  let decodedValue = null;
  if (itemStr != null) {
    decodedValue = JSON.parse(atob(itemStr));
  }
  const item = decodedValue;
  const now = new Date().setHours(0, 0, 0, 0);

  // compare the expiry time of the item with the current time
  //  if (item.expiry < now) {
  // If the item is expired, delete the item from storage
  // and return null
  //  localStorage.removeItem(key);
  //return null;
  //}
  return item.value;
}
